import React, { useContext } from 'react';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import {
  ThemeOverride,
  ThemeSurface,
} from '@wix/da-react-context/pkg/ThemeContext';
import { SubmitFormContext } from '../../../context';
import s from './LiteraturePreview.scss';

const LiteraturePreview: React.FC<{}> = () => {
  const { initResponse } = useContext(SubmitFormContext)!;
  const deviation = initResponse?.deviation;

  if (!deviation) {
    return null;
  }

  return (
    <ThemeOverride themeSurface={ThemeSurface.SECONDARY} className={s['root']}>
      <Dumbo
        className={'ds-card'}
        deviation={deviation}
        width={280}
        height={280}
      />
    </ThemeOverride>
  );
};
LiteraturePreview.displayName = 'LiteraturePreview';

export default LiteraturePreview;
